









import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TooltipContainer extends Vue {
  @Prop() data!: string;
  @Prop() bottom!: boolean | undefined;

  clicked($event: any) {}
}

const component = TooltipContainer;
